import { ComponentStory, ComponentMeta } from '@storybook/react';
import { OpenInNew } from '@mui/icons-material';
import { Button as ButtonComponent } from './button';
import ThemeTokenContextProvider from '../../../providers/themeTokenProvider';

export default {
  title: '2-component/Button',
  component: ButtonComponent,
} as ComponentMeta<typeof ButtonComponent>;

const Template: ComponentStory<typeof ButtonComponent> = (args:any) => (
  <ThemeTokenContextProvider>
    <ButtonComponent {...args} />
  </ThemeTokenContextProvider>
);

export const Button = Template.bind({});
Button.args = {
  variant: 'filled',
  label: 'Button',
};

export const LeadingIcon = Template.bind({});
LeadingIcon.args = {
  variant: 'filled',
  label: 'Button',
  leadingIcon: OpenInNew,
};

export const TrailingIcon = Template.bind({});
TrailingIcon.args = {
  variant: 'filled',
  label: 'Button',
  trailingIcon: OpenInNew,
};
